<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VPhoneInput } from 'v-phone-input'

import { isValidEmail } from '@/utils/validation'

import 'flag-icons/css/flag-icons.min.css'
import 'v-phone-input/styles'

// Page 1 of SProfileDialog: mobile number (+ email unless the mobile-only flow).
// Field-level rules validate format; the REQUIRED-ness of email/mobile in the full
// flow is enforced by the parent's button-disabled logic (legacy parity).
const { mobileNumberOnly } = defineProps<{ mobileNumberOnly?: boolean }>()
const email = defineModel<string>('email', { required: true })
const mobileNumber = defineModel<string>('mobileNumber', { required: true })

const { t } = useI18n()

function emailRule(value: string) {
  return value === '' || isValidEmail(value) || t('common.invalid_email')
}

function requiredRule(value: string) {
  return value !== '' || t('common.required')
}
</script>

<template>
  <div class="text-body-medium px-6 pt-2">
    {{ t(mobileNumberOnly ? 'common.you_need_to_enter_your_phone_number' : 'common.how_may_we_be_in_touch_text') }}
  </div>

  <div class="px-6 pt-6">
    <v-phone-input
      v-model="mobileNumber"
      :country-label="t('common.country')"
      :invalid-message="t('common.invalid_mobile_number')"
      :label="t('common.mobile_number')"
      :prefer-countries="['SE', 'DK', 'NO', 'FI', 'IS']"
      :rules="mobileNumberOnly ? [requiredRule] : []"
      country-icon-mode="svg"
      default-country="SE"
      variant="outlined"
      class="mb-4"
    />

    <v-text-field
      v-if="!mobileNumberOnly"
      v-model="email"
      :label="t('common.email')"
      :rules="[emailRule]"
      placeholder="example@example.com"
      type="email"
    />
  </div>
</template>
